import styled from 'styled-components';
import { ThemeInterface } from '../theme/ThemeInterface';
import { themeGet } from '@styled-system/theme-get';

const H3 = styled.h3`
  font-family: ${(props: ThemeInterface) => props.theme.fontFamily};
  font-size: ${themeGet('fontSize[2]', '20px')};
  font-weight: 100;
  color: ${themeGet('colors.primary', '#222429')};
  text-transform: ${(props: ThemeInterface) => props.textTransform || 'none'};
`;

export default H3;
